import Typography from '@mui/material/Typography';
import { abbreviateNumericValue } from '@openx/utils/lib/abbreviateNumericValue';

type NumericCellProps = {
  value: number | null | undefined;
  decimalPlaces?: number;
  prefix?: string;
  suffix?: string;
  trailingZeroes?: boolean;
};

export const NumericCell = ({ value, decimalPlaces = 0, prefix, suffix, trailingZeroes }: NumericCellProps) => {
  if (value === null || value === undefined) {
    return null;
  }

  if (value === 0) {
    return (
      <Typography component="span">
        {prefix ?? ''}0{suffix ?? ''}
      </Typography>
    );
  }

  return (
    <Typography component="span">
      {(prefix ?? '') + abbreviateNumericValue(value, { decimalPlaces, trailingZeroes }) + (suffix ?? '')}
    </Typography>
  );
};
